import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowRealTimeEligibilityBlockConfigSchema = z.object({
    patientInsuranceInformationId: z.string(),
    npi: z.string(),
});
export const FlowRealTimeEligibilityBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.RealTimeEligibility),
    config: FlowRealTimeEligibilityBlockConfigSchema,
});
//# sourceMappingURL=config.js.map